export const TOGGLE_SELECT_VR_SCREEN_MODE = "Toggle Select VR Screen Mode";
export const REQUEST_TREE_DATA = 'requestTreeData'